import { PagePaths } from '@/routes/page-paths';

/**
 * Builds the investing wizard URL for a given fund + investment. The wizard
 * (`/all-funds/:identifier/invest?investmentId=...`) auto-resumes to the
 * correct step from the investment's stage — see `getActiveWizardView`
 * in the wizard's own `common.ts`. Shared by the Invest Now panel (new
 * investment), Pending Assets row actions (Resume / Payment Details), and the
 * "Finalize this investment" modal (ticket 06) so all three build the same
 * link the same way.
 */
export const getInvestWizardPath = (fundIdentifier: string, investmentId: string): string =>
  `${PagePaths.allFunds}/${fundIdentifier}/invest?investmentId=${investmentId}`;
